import { configureStore } from '@reduxjs/toolkit'
import companyReducer from './company/company.reducer'
import userReducer from './user/user.reducer'

const store = configureStore({
  reducer: {
    company: companyReducer,
    user:userReducer,
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store